/* eslint-disable use-isnan */
/* eslint-disable max-len */
import React from "react";
import "./style.scss";
import { QlikProvider } from "./context/Qlik";
import { FilterBarProvider } from "./context/FilterBar";
import { BookMarkProvider } from "./context/BookMarkContainer";
import { LeftBarProvider } from "./context/LeftBar";
import { ConfigProvider } from "./context/Config";
import Layout from "./pages/Layout";
import { FiltersProvider } from "./context/Filters";
import { ModalProvider } from "./context/Modal";
import { ExportIdProvider } from "./context/ExportId";
import { SelectionsProvider } from "./context/Selections";
import { setCookie } from "nookies";
import { DefaultsProvider } from "./context/useSelectFilter";

function App() {
  const query = new URLSearchParams(window.location.search);
  if (query.get("u")) {
    setCookie(null, "userHash", query.get("u"), {
      path: "/",
      maxAge: 72576000,
      secure: true,
      domain: ".mtrix.com.br",
    });
  }
  const config = {
    host: process.env.REACT_APP_HOST,
    prefix: process.env.REACT_APP_PREFIX,
    port:
      parseInt(process.env.REACT_APP_PORT) !== NaN
        ? process.env.REACT_APP_PORT
        : parseInt(process.env.REACT_APP_PORT),
    isSecure:
      process.env.REACT_APP_IS_SECURE === "true" ||
      process.env.REACT_APP_IS_SECURE,
  };

  return (
    <QlikProvider config={config}>
      <SelectionsProvider>
        <BookMarkProvider>
          <ModalProvider>
            <FilterBarProvider>
              <LeftBarProvider>
                <ConfigProvider>
                  <DefaultsProvider>
                    <FiltersProvider>
                      <ExportIdProvider>
                        <Layout />
                      </ExportIdProvider>
                    </FiltersProvider>
                  </DefaultsProvider>
                </ConfigProvider>
              </LeftBarProvider>
            </FilterBarProvider>
          </ModalProvider>
        </BookMarkProvider>
      </SelectionsProvider>
    </QlikProvider>
  );
}

export default App;
